import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClientProvider } from '@tanstack/react-query';
import { App } from './App.tsx';
import { BrandingProvider } from './lib/branding.tsx';
import { AdminAuthProvider } from './lib/auth/admin.tsx';
import { CompanyAuthProvider } from './lib/auth/company.tsx';
import { queryClient } from './lib/queryClient.ts';
import './index.css';

const root = document.getElementById('root');
if (!root) throw new Error('Root element missing');

createRoot(root).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrandingProvider>
        <BrowserRouter>
          <AdminAuthProvider>
            <CompanyAuthProvider>
              <App />
            </CompanyAuthProvider>
          </AdminAuthProvider>
        </BrowserRouter>
      </BrandingProvider>
    </QueryClientProvider>
  </StrictMode>,
);
